import { render, staticRenderFns } from "./SubjectAreaFilter.vue?vue&type=template&id=405cea56&"
import script from "./SubjectAreaFilter.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreaFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports